module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product27-7b317bd8a10e405ad8ea0ff751288c25.jpg";